import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import StencilPanelize from 'pu-react/components/StencilPanelize';
import PrintConfirmationRadio from 'pu-react/components/PrintConfirmationRadio';
import SpecialInstruction from 'pu-react/components/SpecialInstruction';

import { changeStencilsParameter, validator } from '../../stencilSlice';

const GroupParameters = () => {
  const dispatch = useDispatch();
  const {
    stencilsParameters: parameters,
    stencils,
  } = useSelector((state) => state.smtStencil);

  if (!stencils || !stencils.length) return null;

  const groupName = 'groupParameters';
  const onChangeParameter = (name, value) => dispatch(changeStencilsParameter({ name, value }));
  return (
    <div className="row">
      <div className="col-lg-6">
        <StencilPanelize
          required={true}
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          errorMessage={validator.message('Panelize', parameters.panelize, 'required')} />
      </div>
      <div className="col-lg-6">
        <PrintConfirmationRadio
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          errorMessage={validator.message('Check Plot', parameters.print_confirmation, 'required')} />
      </div>
      <div className="col-lg-12">
        <SpecialInstruction
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          rows="2" />
      </div>
    </div>
  )
};

export default GroupParameters;